<template>
  <div class="card-body">
    <h4 id="header-basic" class="card-title card-collapse ">
      <span class="pointer" @click="onClickCollapse">Basic Information</span>
      <!-- <span class="f-10 ml-2">Description Lorem Ipsom</span> -->
      <span class="f-10 ml-2">
        <b-icon
          icon="exclamation-circle-fill"
          variant="danger"
          animation="throb"
          font-scale="2"
          v-if="!basicComponentModel.validateState"
          @click="
            basicComponentModel.collapseState = !basicComponentModel.collapseState
          "
        ></b-icon>
      </span>
      <span class="icon-collapse">
        <!-- <i
          class="mdi mdi-comment-plus-outline text-danger i-add-comment font-size-18 mr-4"
          v-b-tooltip.hover
          title="Add comment"
          @click="addCommentClick"
        ></i> -->
        <button
          class="btn-icon-collapse"
          @click="
            basicComponentModel.collapseState = !basicComponentModel.collapseState
          "
        >
          <template>
            <i
              v-if="basicComponentModel.collapseState"
              class="dripicons-minus"
            />
            <i v-else class="dripicons-plus" />
          </template>
        </button>
      </span>
    </h4>
    <b-collapse
      id="collapse-basic"
      v-model="basicComponentModel.collapseState"
      @input="modelChanged"
    >
      <validationObserver ref="componentForm" tag="form">
        <form @submit.prevent="onSubmit" @reset="onReset">
          <div class="pt-3">
            <div class="row">
              <div class="col-12">
                <div class="border-top pb-4"></div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="form-row form-group"
                v-if="userInfo.user_type === 'Operator'">
                  <label
                    class="col-lg-4 col-xl-3 col-form-label"
                  >
                    Business Unit
                  </label>
                  <div class="col-sm-8 mb-2">
                    <validationProvider
                      v-slot="{ errors }"
                      :rules="(basicComponentModel.model.business_unit.length == 0) ?
                        {
                          dynamicRequired: ['กรุณาระบุข้อมูล'],
                        } : {}">
                      <b-form-group>
                        <b-form-checkbox-group
                          v-model="basicComponentModel.model.business_unit"
                          :options="business_unit"
                        ></b-form-checkbox-group>
                      </b-form-group>
                      <span
                          v-if="errors && errors.length"
                          class="validate-invalid"
                          style="top:23px"
                        >
                          {{ errors[0] }}
                      </span>
                    </validationProvider>
                  </div>
                </div>
                <div class="form-row form-group">
                  <label
                    class="col-lg-4 col-xl-3 col-form-label"
                    for="categories_hybrid"
                  >
                    หมวดหมู่
                  </label>
                  <div
                    class="col-sm-8"
                    v-if="
                      dataPermissions.find(f => f.name === 'hybird_category')
                        .isEditable === false
                    "
                  >
                    <input
                      type="text"
                      class="form-control"
                      :value="hybridRoot"
                      readonly
                    />
                  </div>
                  <div class="col-sm-8" v-else>
                    <validationProvider>
                      <hybridcategory-selector
                        :level="5"
                        :displayKey="`view_name`"
                        :idKey="`view_id`"
                        :childrenItemsKey="`items`"
                        :defaultValue="hybrid_category_id"
                        :isValidate="isValidate.hybridCategory"
                        :items="hybridCategoryItems"
                        :reload="isReloadHybridCategorySelector"
                        @result="onHybridCategorySelector"
                        :isSelectLastChild="true"
                        :class="{ 'is-invalid': 0 }"
                        style="margin-bottom: -1rem"
                        @resetitems="getHybridCategory()"
                      ></hybridcategory-selector>
                    </validationProvider>
                  </div>
                </div>
                <div
                  v-if="userInfo.user_type === 'Operator'"
                  class="form-row form-group"
                >
                  <label
                    class="col-lg-4 col-xl-3 col-form-label"
                    for="categories_ofm"
                    >Inventory</label
                  >
                  <div
                    class="col-sm-8"
                    v-if="
                      dataPermissions.find(f => f.name === 'inventory_category')
                        .isEditable === false ||
                        hybrid_category_id == null ||
                        hybrid_category_id == undefined ||
                        hybrid_category_id == '' ||
                        isValidate.hybridCategory
                    "
                  >
                    <input
                      type="text"
                      class="form-control"
                      :value="inventoryRoot"
                      readonly
                    />
                  </div>
                  <div class="col-sm-8" v-else>
                    <validationProvider>
                      <hybridcategory-selector
                        :isValidate="isValidate.inventoryCategory"
                        :level="5"
                        :displayKey="`view_name`"
                        :idKey="`view_id`"
                        :childrenItemsKey="`items`"
                        :defaultValue="inventory_category_id"
                        :items="inventoryCategoryItems"
                        :reload="isReloadInventoryCategorySelector"
                        @result="onInventoryCategorySelector"
                        :isSelectLastChild="true"
                        style="margin-bottom: -1rem"
                        @resetitems="getInventoryCategory(is_free, vendor_type)"
                      ></hybridcategory-selector>
                    </validationProvider>
                  </div>
                </div>
                <div
                  v-if="userInfo.user_type === 'Operator'"
                  class="form-row form-group"
                >
                  <label
                    class="col-lg-4 col-xl-3 col-form-label"
                    for="categories_jda"
                    >JDA</label
                  >
                  <div
                    class="col-sm-8"
                    v-if="
                      dataPermissions.find(f => f.name === 'jda_category')
                        .isEditable === false ||
                        hybrid_category_id == null ||
                        hybrid_category_id == undefined ||
                        hybrid_category_id == '' ||
                        isValidate.hybridCategory
                    "
                  >
                    <input
                      type="text"
                      class="form-control"
                      :value="jdaRoot"
                      readonly
                    />
                  </div>
                  <div class="col-sm-8" v-else>
                    <validationProvider>
                      <hybridcategory-selector
                        :isValidate="isValidate.jdaCategory"
                        :level="5"
                        :displayKey="`view_name`"
                        :idKey="`view_id`"
                        :childrenItemsKey="`items`"
                        :defaultValue="jda_category_id"
                        :items="jdaCategoryItems"
                        :reload="isReloadJDACategorySelector"
                        :isSelectLastChild="true"
                        @result="onJDACategorySelector"
                        style="margin-bottom: -1rem"
                        @resetitems="getJDACategory(is_free, vendor_type)"
                      ></hybridcategory-selector>
                    </validationProvider>
                  </div>
                </div>
                <div
                  v-if="userInfo.user_type === 'Operator'"
                  class="form-row form-group"
                >
                  <label
                    class="col-lg-4 col-xl-3 col-form-label"
                    for="categories_online"
                    >Online</label
                  >
                  <div
                    class="col-sm-8"
                    v-if="
                      dataPermissions.find(f => f.name === 'online_category')
                        .isEditable === false ||
                        hybrid_category_id == null ||
                        hybrid_category_id == undefined ||
                        hybrid_category_id == '' ||
                        isValidate.hybridCategory
                    "
                  >
                    <input
                      type="text"
                      class="form-control"
                      :value="onlineRoot"
                      readonly
                    />
                  </div>
                  <div class="col-sm-8" v-else>
                    <validationProvider>
                      <hybridcategory-selector
                        :isValidate="isValidate.onlineCategory"
                        :level="5"
                        :displayKey="`view_name`"
                        :idKey="`view_id`"
                        :childrenItemsKey="`items`"
                        :defaultValue="online_category_id"
                        :items="onlineCategoryItems"
                        :reload="isReloadOnlineCategorySelector"
                        :isSelectLastChild="true"
                        @result="onOnlineCategorySelector"
                        style="margin-bottom: -1rem"
                        @resetitems="getOnlineCategory()"
                      ></hybridcategory-selector>
                    </validationProvider>
                  </div>
                </div>
                <div class="form-row form-group">
                  <label class="col-lg-4 col-xl-3 col-form-label" for="brand"
                    >แบรนด์</label
                  >
                  <div class="col-sm-8">
                    <validationProvider
                      v-slot="{ errors }"
                      name="Basic Brand Selector"
                      :rules="{ validateDisplayNameObjectEng: true }"
                    >
                      <search-selector
                        v-model="basicComponentModel.model.brand"
                        :options="options_brand"
                        :isError="errors && errors.length > 0"
                        placeholder="ระบุแบรนด์"
                        @get="onGetBrandSelector"
                        @select="setIsOwnBrand"
                        :isDisabled="
                          dataPermissions.find(f => f.name === 'brand')
                            .isEditable === false
                        "
                      >
                      </search-selector>
                      <span
                        v-if="
                          requestDocumentInformation === null &&
                            dataPermissions.find(f => f.name === 'brand')
                              .isEditable === true
                        "
                        class="validate-textbox"
                      >
                        ถ้าเป็นสินค้าไม่มีแบรนด์ให้เลือก Non-Brand
                        แต่ถ้าไม่พบแบรนด์ที่ต้องการให้ทำการ
                      </span>
                      <router-link
                        v-if="
                          requestDocumentInformation === null &&
                            dataPermissions.find(f => f.name === 'brand')
                              .isEditable === true
                        "
                        target="_blank"
                        :to="{
                          name: 'brand_detail',
                          params: { id: 'new' },
                        }"
                        >เพิ่มแบรนด์ใหม่
                      </router-link>
                      <span
                        v-if="errors && errors.length"
                        class="validate-invalid"
                      >
                        {{ `กรุณาระบุข้อมูล` }}
                      </span>
                    </validationProvider>
                  </div>
                </div>
                <div class="form-row">
                  <label class="col-lg-4 col-xl-3 col-form-label" for="series"
                    >รุ่น</label
                  >
                  <div class="col-sm-8">
                    <b-row>
                      <b-col cols="12" class="form-group mb-1">
                        <validationProvider
                          v-slot="{ errors }"
                          name="Basic Series Selector TH"
                          :rules="{
                            dynamicRequired: ['กรุณาระบุข้อมูล'],
                            validateSingleQuote: true,
                          }"
                        >
                          <series-input
                            v-model="
                              basicComponentModel.model.series.display_name.th
                            "
                            prepend="TH"
                            :errors="errors"
                            lang="th"
                            @selected="
                              val => {
                                basicComponentModel.model.series.display_name.en =
                                  val.display_name.en
                                basicComponentModel.model.series.id = val.id
                              }
                            "
                            @input="basicComponentModel.model.series.id = null"
                            :isDisabled="
                              dataPermissions.find(f => f.name === 'series')
                                .isEditable === false
                            "
                          >
                          </series-input>
                        </validationProvider>
                      </b-col>
                      <b-col cols="12" class="form-group mb-1">
                        <validationProvider
                          v-slot="{ errors }"
                          name="Basic Series Selector EN"
                          :rules="{
                            dynamicRequired: ['กรุณาระบุข้อมูล'],
                            validateSingleQuote: true,
                          }"
                        >
                          <series-input
                            v-model="
                              basicComponentModel.model.series.display_name.en
                            "
                            prepend="EN"
                            :errors="errors"
                            lang="en"
                            @selected="
                              val => {
                                basicComponentModel.model.series.display_name.th =
                                  val.display_name.th
                                basicComponentModel.model.series.id = val.id
                              }
                            "
                            @input="basicComponentModel.model.series.id = null"
                            :isDisabled="
                              dataPermissions.find(f => f.name === 'series')
                                .isEditable === false
                            "
                          >
                          </series-input>
                        </validationProvider>
                      </b-col>
                    </b-row>
                  </div>
                </div>
                <div
                  v-for="(product_name, index) in basicComponentModel.model
                    .product_names"
                  :key="index"
                >
                  <div class="form-row form-group">
                    <label
                      class="col-lg-4 col-xl-3 col-form-label"
                      :for="`product_name_${product_name.type}_${index}_th`"
                      >{{
                        product_name.type == 'Vendor'
                          ? 'ชื่อสินค้าตั้งต้น'
                          : 'ชื่อกลุ่มสินค้า'
                      }}
                      <i
                        class="ml-1 bx bx-info-circle align-middle absolute text-grey f-18"
                        :id="`product_name_${product_name.type}_${index}_th`"
                      />
                      <b-tooltip
                        v-if="product_name.type == 'Vendor'"
                        :target="
                          `product_name_${product_name.type}_${index}_th`
                        "
                        placement="right"
                        variant="info"
                      >
                        ชื่อของสินค้าหรือชื่อของผลิตภัณฑ์เท่านั้น
                        ไม่มีข้อมูลเรื่องแบรนด์ รุ่น สี ขนาด</b-tooltip
                      >
                      <b-tooltip
                        v-else
                        :target="
                          `product_name_${product_name.type}_${index}_th`
                        "
                        placement="right"
                        variant="info"
                      >
                        ชื่อของกลุ่มสินค้าที่ใช้ภายในระบบ PIM
                        ประกอบด้วยชื่อสินค้า แบรนด์ และรุ่น
                        ระบบจะดำเนินการสร้างให้อัตโนมัติ
                        ไม่สามารถแก้ไขได้</b-tooltip
                      >
                    </label>

                    <div class="col-sm-8">
                      <validationProvider
                        v-slot="{ errors }"
                        :name="`product_name_${product_name.type}_${index}_th`"
                        :rules="{
                          dynamicRequired: ['กรุณาระบุข้อมูล'],
                          validateSingleQuote: true,
                        }"
                      >
                        <div role="group" class="input-group check-length">
                          <div class="input-group-prepend">
                            <div class="input-group-text">
                              TH
                            </div>
                          </div>
                          <input
                            :readonly="
                              product_name.type == 'PIM' ||
                                dataPermissions.find(
                                  f => f.name === 'product_names'
                                ).isEditable === false
                            "
                            :id="
                              `product_name_${product_name.type}_${index}_th`
                            "
                            :name="
                              `product_name_${product_name.type}_${index}_th`
                            "
                            type="text"
                            maxlength="55"
                            class="form-control"
                            v-model="product_name.display_name.th"
                            :class="{ 'is-invalid': errors.length }"
                          />
                          <span
                            v-if="product_name.display_name.th"
                            class="badge input-validate-length"
                            :class="{
                              'badge-success':
                                product_name.display_name.th.length !== 55,
                              'badge-danger':
                                product_name.display_name.th.length === 55,
                            }"
                            >{{ product_name.display_name.th.length }}/55</span
                          >
                          <span v-if="errors.length" class="validate-invalid">
                            {{ errors[0] }}
                          </span>
                        </div>
                      </validationProvider>
                    </div>
                  </div>
                  <div class="form-row form-group">
                    <label
                      class="col-lg-4 col-xl-3 col-form-label"
                      :for="`product_name_${product_name.type}_${index}_en`"
                    ></label>
                    <div class="col-sm-8">
                      <validationProvider
                        v-slot="{ errors }"
                        :name="`product_name_${product_name.type}_${index}_en`"
                        :rules="{
                          dynamicRequired: ['กรุณาระบุข้อมูล'],
                          validateSingleQuote: true,
                        }"
                      >
                        <div role="group" class="input-group check-length">
                          <div class="input-group-prepend">
                            <div class="input-group-text">
                              EN
                            </div>
                          </div>
                          <input
                            :readonly="
                              product_name.type == 'PIM' ||
                                dataPermissions.find(
                                  f => f.name === 'product_names'
                                ).isEditable === false
                            "
                            :id="
                              `product_name_${product_name.type}_${index}_en`
                            "
                            :name="
                              `product_name_${product_name.type}_${index}_en`
                            "
                            type="text"
                            maxlength="55"
                            class="form-control"
                            v-model="product_name.display_name.en"
                            :class="{ 'is-invalid': errors.length }"
                          />
                          <span
                            v-if="product_name.display_name.en"
                            class="badge input-validate-length"
                            :class="{
                              'badge-success':
                                product_name.display_name.en.length !== 55,
                              'badge-danger':
                                product_name.display_name.en.length === 55,
                            }"
                            >{{ product_name.display_name.en.length }}/55</span
                          >
                          <span v-if="errors.length" class="validate-invalid">
                            {{ errors[0] }}
                          </span>
                        </div>
                      </validationProvider>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </validationObserver>
    </b-collapse>
  </div>
</template>
<script>
import MappingHybridCategorySelector from '@/components/mappinghybridcategory/mapping-hybrid-category-selector'
import hybridCategoryService from '@/helpers/service/hybrid-category-service'
import jdaCategoryService from '@/helpers/service/jda-category-service'
import inventoryCategoryService from '@/helpers/service/inventory-category-service'
import onlineCategoryService from '@/helpers/service/online-category-service'
import SearchSelector from '@/components/share/search-selector'
import seriesService from '@/helpers/service/series-service'
import brandService from '@/helpers/service/brand-service'
import { StatusEnum } from '@/enum/status.enum.js'
import { eventBus } from '@/main.js'
import { getUserInfo } from '@/helpers/utils/jwt'
import { authComputed } from '@/state/helpers'
import SeriesInput from '@/components/product-register/sections/basic-components/series-input.vue'

export default {
  name: 'Basic',
  components: {
    'hybridcategory-selector': MappingHybridCategorySelector,
    'search-selector': SearchSelector,
    'series-input': SeriesInput,
  },
  props: {
    value: {
      type: Object,
      default: () => {
        return this.basicComponentModel
      },
    },
    vendor_type: {
      type: String,
      default: () => {
        return ''
      },
    },
    is_free: {
      type: Boolean,
      default: () => {
        return false
      },
    },
    is_view: {
      type: Boolean,
      default: () => {
        return false
      },
    },
    requestDocumentInformation: {
      type: Object,
      default: () => {
        return null
      },
    },
    vendor_code: {
      type: String,
      default: () => {
        return ''
      },
    },
  },
  data() {
    return {
      isReloadHybridCategorySelector: false,
      isReloadJDACategorySelector: false,
      isReloadInventoryCategorySelector: false,
      isReloadOnlineCategorySelector: false,
      hybridCategoryItems: [],
      jdaCategoryItems: [],
      inventoryCategoryItems: [],
      onlineCategoryItems: [],
      options_series: [],
      options_brand: [],
      hybrid_category_id: '',
      jda_category_id: '',
      inventory_category_id: '',
      online_category_id: '',
      basicComponentModel: {
        collapseState: false,
        validateState: false,
        isPayloadChanged: false,
        model: {
          categories: [
            {
              type: 'Hybrid',
              id: '',
              parent_id: '',
              level: 0,
              code: '',
              display_name: { en: '', th: '' },
              parent_categories: [],
            },
            {
              type: 'Inventory',
              id: '',
              parent_id: '',
              level: 0,
              code: '',
              display_name: { en: '', th: '' },
              parent_categories: [],
            },
            {
              type: 'JDA',
              id: '',
              parent_id: '',
              level: 0,
              code: '',
              display_name: { en: '', th: '' },
              parent_categories: [],
            },
            {
              type: 'Online',
              id: '',
              parent_id: '',
              level: 0,
              code: '',
              display_name: { en: '', th: '' },
              parent_categories: [],
            },
          ],
          oracle_code: '',
          commission_rate: 0.0,
          gp_standard: 0.0,
          is_best_deal: false,
          brand: { id: '', display_name: { en: '', th: '' } },
          series: {
            id: '',
            display_name: { en: 'Non-Series', th: 'Non-Series' },
          },
          product_names: [
            {
              type: 'Vendor',
              display_name: { en: '', th: '' },
            },
            {
              type: 'PIM',
              display_name: { en: '', th: '' },
            },
          ],
          business_unit : []
        },
        commission_rate_type: 'Standard'
      },
      isValidate: {
        hybridCategory: false,
        inventoryCategory: false,
        jdaCategory: false,
        onlineCategory: false,
      },
      timerCount: 10,
      permissions: [
        {
          name: 'hybird_category',
          ruleIDs: ['P1', 'P2', 'P3', 'P5', 'P6', 'P7', 'P8'],
          isEditable: false,
        },
        {
          name: 'inventory_category',
          ruleIDs: ['P1', 'P2', 'P3', 'P6', 'P7', 'P8'],
          isEditable: false,
        },
        {
          name: 'jda_category',
          ruleIDs: ['P1', 'P2', 'P3', 'P6', 'P7', 'P8'],
          isEditable: false,
        },
        {
          name: 'online_category',
          ruleIDs: ['P1', 'P2', 'P3', 'P5', 'P6', 'P7', 'P8'],
          isEditable: false,
        },
        {
          name: 'brand',
          ruleIDs: ['P1', 'P2', 'P3', 'P6', 'P7', 'P8'],
          isEditable: false,
        },
        {
          name: 'series',
          ruleIDs: ['P1', 'P2', 'P3', 'P6', 'P7', 'P8'],
          isEditable: false,
        },
        {
          name: 'product_names',
          ruleIDs: ['P1', 'P2', 'P3', 'P6', 'P7', 'P8'],
          isEditable: false,
        },
      ],
      isFirstWatchValue: true,
      business_unit : [
        { text: 'OFM', value: 'OFM' },
        { text: 'B2S', value: 'B2S' },
      ],
    }
  },
  created() {
    eventBus.$on('collapse-basic', text => {
      this.basicComponentModel.collapseState = true
      this.onSubmit()
    })
  },
  async mounted() {
    await this.getHybridCategory()
    await this.getJDACategory(this.is_free, this.vendor_type)
    await this.getInventoryCategory(this.is_free, this.vendor_type)
    await this.getOnlineCategory()
    this.$nextTick(() => {
      this.onSubmit()
    })
  },
  computed: {
    ...authComputed,
    userInfo() {
      if (this.getAccessToken !== null) {
        return getUserInfo(this.getAccessToken)
      } else return {}
    },
    product_pim_en() {
      let brand_name_en = ''
      let series_name_en = ''
      let product_vendor = ''
      let result = ''
      if (this.basicComponentModel.model.brand) {
        brand_name_en = this.basicComponentModel.model.brand.display_name.en
        brand_name_en =
          brand_name_en == 'Non-Brand' || brand_name_en == 'Non-Brand-'
            ? ''
            : brand_name_en.trim()
      }
      if (this.basicComponentModel.model.series) {
        series_name_en = this.basicComponentModel.model.series.display_name.en
        series_name_en =
          series_name_en.trim() == 'Non-Series' ? '' : series_name_en.trim()
      }
      if (
        this.basicComponentModel.model.product_names &&
        this.basicComponentModel.model.product_names.some(
          f => f.type == 'Vendor'
        )
      ) {
        product_vendor = this.basicComponentModel.model.product_names
          .find(f => f.type == 'Vendor')
          .display_name.en.trim()
      }
      result = brand_name_en + ' ' + product_vendor + ' ' + series_name_en

      return result.trim()
    },
    product_pim_th() {
      let brand_name_th = ''
      let series_name_th = ''
      let result = ''
      if (this.basicComponentModel.model.brand) {
        brand_name_th = this.basicComponentModel.model.brand.display_name.th
        brand_name_th =
          brand_name_th == 'Non-Brand' || brand_name_th == 'Non-Brand-'
            ? ''
            : brand_name_th.trim()
      }
      if (this.basicComponentModel.model.series) {
        series_name_th = this.basicComponentModel.model.series.display_name.th
        series_name_th =
          series_name_th.trim() == 'Non-Series' ? '' : series_name_th.trim()
      }
      if (
        this.basicComponentModel.model.product_names &&
        this.basicComponentModel.model.product_names.some(
          f => f.type == 'Vendor'
        )
      ) {
        result =
          this.basicComponentModel.model.product_names
            .find(f => f.type == 'Vendor')
            .display_name.th.trim() +
          ' ' +
          brand_name_th +
          ' ' +
          series_name_th
      }

      return result.trim()
    },
    dataPermissions() {
      let permissions = this.permissions
      if (
        this.requestDocumentInformation !== null &&
        this.requestDocumentInformation !== undefined &&
        this.requestDocumentInformation.approval_documents !== null &&
        this.requestDocumentInformation.approval_documents !== undefined
      ) {
        let ruleEditables = this.requestDocumentInformation.approval_documents
          .filter(f => f.my_process_action.can_edit === true)
          .map(m => m.rule_id)

        permissions
          .filter(f => f.ruleIDs.some(s => ruleEditables.some(r => r === s)))
          .forEach(element => {
            element.isEditable = true
          })
      } else {
        permissions.forEach(element => {
          element.isEditable = this.is_view ? false : true
        })
      }
      return permissions
    },
    hybridRoot() {
      let root = ''
      if (
        this.hybrid_category_id !== '' &&
        this.basicComponentModel.model.categories &&
        this.basicComponentModel.model.categories.some(
          f => f.type == 'Hybrid'
        ) &&
        this.basicComponentModel.model.categories.find(f => f.type == 'Hybrid')
          .id !== ''
      ) {
        let category = this.basicComponentModel.model.categories.find(
          f => f.type == 'Hybrid'
        )
        let sub_root = ''
        if (
          category.parent_categories &&
          category.parent_categories.length > 0
        ) {
          category.parent_categories
            .sort((a, b) => (a.level > b.level ? 1 : -1))
            .forEach(el => {
              sub_root += `${el.display_name.th} (${el.code}) > `
            })
        }
        root = `${sub_root}${category.display_name.th} (${category.code})`
      }

      return root
    },
    inventoryRoot() {
      let root = ''
      if (
        this.inventory_category_id !== '' &&
        this.basicComponentModel.model.categories &&
        this.basicComponentModel.model.categories.some(
          f => f.type == 'Inventory'
        ) &&
        this.basicComponentModel.model.categories.find(
          f => f.type == 'Inventory'
        ).id !== ''
      ) {
        let category = this.basicComponentModel.model.categories.find(
          f => f.type == 'Inventory'
        )
        let sub_root = ''
        if (
          category.parent_categories &&
          category.parent_categories.length > 0
        ) {
          category.parent_categories
            .sort((a, b) => (a.level > b.level ? 1 : -1))
            .forEach(el => {
              sub_root += `${el.display_name.th} (${el.code}) > `
            })
        }
        root = `${sub_root}${category.display_name.th} (${category.code})`
      }

      return root
    },
    jdaRoot() {
      let root = ''
      if (
        this.jda_category_id !== '' &&
        this.basicComponentModel.model.categories &&
        this.basicComponentModel.model.categories.some(f => f.type == 'JDA') &&
        this.basicComponentModel.model.categories.find(f => f.type == 'JDA')
          .id !== ''
      ) {
        let category = this.basicComponentModel.model.categories.find(
          f => f.type == 'JDA'
        )
        let sub_root = ''
        if (
          category.parent_categories &&
          category.parent_categories.length > 0
        ) {
          category.parent_categories
            .sort((a, b) => (a.level > b.level ? 1 : -1))
            .forEach(el => {
              sub_root += `${el.display_name.th} (${el.code}) > `
            })
        }
        root = `${sub_root}${category.display_name.th} (${category.code})`
      }

      return root
    },
    onlineRoot() {
      let root = ''
      if (
        this.online_category_id !== '' &&
        this.basicComponentModel.model.categories &&
        this.basicComponentModel.model.categories.some(
          f => f.type == 'Online'
        ) &&
        this.basicComponentModel.model.categories.find(f => f.type == 'Online')
          .id !== ''
      ) {
        let category = this.basicComponentModel.model.categories.find(
          f => f.type == 'Online'
        )
        let sub_root = ''
        if (
          category.parent_categories &&
          category.parent_categories.length > 0
        ) {
          category.parent_categories
            .sort((a, b) => (a.level > b.level ? 1 : -1))
            .forEach(el => {
              sub_root += `${el.display_name.th} (${el.code}) > `
            })
        }
        root = `${sub_root}${category.display_name.th} (${category.code})`
      }

      return root
    },
  },
  watch: {
    vendor_type: {
      handler(value) {
        this.getJDACategory(this.is_free, value)
        this.getInventoryCategory(this.is_free, value)

        this.isReloadJDACategorySelector = !this.isReloadJDACategorySelector
        this.isReloadInventoryCategorySelector = !this
          .isReloadInventoryCategorySelector
      },
      deep: true,
    },
    timerCount: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.timerCount--
            // console.log(this.timerCount)
          }, 1000)
        }
      },
      immediate: true, // This ensures the watcher is triggered upon creation
    },
    value: {
      handler(val) {
        if (val && this.isFirstWatchValue) {
          this.basicComponentModel = val
          this.$nextTick(async () => {
            if (val.model.categories.some(f => f.type == 'Hybrid')) {
              this.hybrid_category_id = val.model.categories.find(
                f => f.type == 'Hybrid'
              ).id
              if (this.hybrid_category_id && this.hybrid_category_id !== '') {
                this.isFirstWatchValue = false
                await this.getHybridCategoryByIdAsync(this.hybrid_category_id)
                this.isValidate.hybridCategory = false
              }
            }
            if (val.model.categories.some(f => f.type == 'Inventory')) {
              this.inventory_category_id = val.model.categories.find(
                f => f.type == 'Inventory'
              ).id
              if (
                this.inventory_category_id &&
                this.inventory_category_id !== ''
              ) {
                await this.getInventoryCategoryByIdAsync(
                  this.inventory_category_id
                )
                this.isValidate.inventoryCategory = false
              }
            }
            if (val.model.categories.some(f => f.type == 'JDA')) {
              this.jda_category_id = val.model.categories.find(
                f => f.type == 'JDA'
              ).id
              if (this.jda_category_id && this.jda_category_id !== '') {
                await this.getJDACategoryByIdAsync(this.jda_category_id)
                this.isValidate.jdaCategory = false
              }
            }
            if (val.model.categories.some(f => f.type == 'Online')) {
              this.online_category_id = val.model.categories.find(
                f => f.type == 'Online'
              ).id
              if (this.online_category_id && this.online_category_id !== '') {
                await this.getOnlineCategoryByIdAsync(this.online_category_id)
                this.isValidate.onlineCategory = false
              }
            }
            this.onSubmit()
          })
        }
      },
      deep: true,
    },
    product_pim_en: {
      handler(val) {
        if (val !== '' && this.basicComponentModel.model.product_names) {
          this.basicComponentModel.model.product_names[
            this.basicComponentModel.model.product_names.findIndex(
              f => f.type === 'PIM'
            )
          ].display_name.en = val.substring(0, 55)
        }
      },
    },
    product_pim_th: {
      handler(val) {
        if (val !== '' && this.basicComponentModel.model.product_names) {
          this.basicComponentModel.model.product_names[
            this.basicComponentModel.model.product_names.findIndex(
              f => f.type === 'PIM'
            )
          ].display_name.th = val.substring(0, 55)
        }
      },
    },
    'basicComponentModel.model': {
      handler(val) {
        if (val) {
          this.onSubmit()
        }
      },
      deep: true,
    },
  },

  methods: {
    onClickCollapse() {
      if (this.vendor_type === '') {
        setTimeout(function() {
          document.getElementById('header-vendor').scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          })
          eventBus.$emit('collapse-vendor', true)
        }, 500)
      } else {
        this.basicComponentModel.collapseState = !this.basicComponentModel
          .collapseState
      }
    },
    modelChanged() {
      this.basicComponentModel.isPayloadChanged = true
      this.$emit('input', this.basicComponentModel)
    },
    async getHybridCategory() {
      this.hybridCategoryItems = []
      let params = new URLSearchParams()
      params.append('status', StatusEnum.ACTIVE)
      params.append('isControlProduct', true)
      let result = await hybridCategoryService.getMappingHybridCategoryTreeNodeAsync(
        params
      )
      if (result.status === 200) {
        if (result.data && result.data.length > 0) {
          this.hybridCategoryItems = result.data
        }
      }
    },
    async getHybridCategoryByIdAsync(id) {
      if (id && id !== '') {
        let params = new URLSearchParams()
        params.append('isRequireParent', true)
        if(this.vendor_type === 'DropShip'){
          params.append('vendorCode', this.vendor_code)
        }    
        let result = await hybridCategoryService.getHybridCategoryDetailAsync(
          id,
          params
        )
        if (result.status === 200) {
          let indexCategory = this.basicComponentModel.model.categories.findIndex(
            f => f.type === 'Hybrid'
          )
          if (indexCategory === -1) {
            indexCategory = this.basicComponentModel.model.categories.length
          }
          this.hybrid_category_id = result.data.id
          this.basicComponentModel.model.categories[indexCategory] = {
            type: 'Hybrid',
            id: result.data.id,
            parent_id: result.data.parent_id,
            level: result.data.level,
            code: result.data.code,
            display_name: {
              en: result.data.display_name.en,
              th: result.data.display_name.th,
            },
            parent_categories: result.data.parent_categories,
          }
          console.log('basicComponent B',this.basicComponentModel.model)
         // Set special commision rate and commission rate type 
          if (result.data.special_commission_rate != null && this.vendor_type == 'DropShip'){
             this.basicComponentModel.model.commission_rate = result.data.special_commission_rate
             this.basicComponentModel.model.commission_rate_type = 'Category' 
          } else{
            this.basicComponentModel.model.commission_rate = result.data.commission_rate
            this.basicComponentModel.model.commission_rate_type = 'Standard' 
          } 
          if (
            this.timerCount === 0 &&
            result.data.categories_mapped &&
            result.data.categories_mapped.length > 0
          ) {
            this.inventory_category_id = ''
            this.jda_category_id = ''
            this.online_category_id = ''
            this.$nextTick(() => {
              let categories_mapped_inventory = result.data.categories_mapped.filter(
                f => f.type === 'Inventory' && f.id && f.id !== ''
              )
              if (
                categories_mapped_inventory &&
                categories_mapped_inventory.length > 0
              ) {
                this.getInventoryCategoryByIdsAsync(
                  categories_mapped_inventory.map(m => m.id)
                )
              }

              let categories_mapped_jda = result.data.categories_mapped.filter(
                f => f.type === 'JDA' && f.id && f.id !== ''
              )
              if (categories_mapped_jda && categories_mapped_jda.length > 0) {
                this.getJDACategoryByIdsAsync(
                  categories_mapped_jda.map(m => m.id)
                )
              }

              let categories_mapped_online = result.data.categories_mapped.find(
                f => f.type === 'Online'
              )
              if (categories_mapped_online) {
                if (
                  categories_mapped_online.id &&
                  categories_mapped_online.id !== ''
                ) {
                  this.online_category_id = categories_mapped_online.id
                  this.getOnlineCategoryByIdAsync(categories_mapped_online.id)
                }
              }
            })
          }
        } else {
          console.log('error', result.response.data.message)
          let indexCategory = this.basicComponentModel.model.categories.findIndex(
            f => f.type === 'Hybrid'
          )
          if (indexCategory === -1) {
            indexCategory = this.basicComponentModel.model.categories.length
          }
          this.hybrid_category_id = ''
          this.basicComponentModel.model.categories[indexCategory] = {
            type: 'Hybrid',
            id: '',
            parent_id: '',
            level: '',
            code: '',
            display_name: {
              en: '',
              th: '',
            },
            parent_categories: [],
          }
        }
      } else {
        let indexCategory = this.basicComponentModel.model.categories.findIndex(
          f => f.type === 'Hybrid'
        )
        if (indexCategory === -1) {
          indexCategory = this.basicComponentModel.model.categories.length
        }
        this.basicComponentModel.model.categories[indexCategory] = {
          type: 'Hybrid',
          id: '',
          parent_id: '',
          level: '',
          code: '',
          display_name: {
            en: '',
            th: '',
          },
          parent_categories: [],
        }
      }
    },
    async onHybridCategorySelector(obj) {
      this.isValidate.hybridCategory = false
      await this.getHybridCategoryByIdAsync(obj.id)
      this.hybrid_category_id = obj.id
    },
    async getJDACategory(is_free, vendor_type) {
      this.jdaCategoryItems = []
      let params = new URLSearchParams()
      params.append('is_free', is_free)
      params.append('type', vendor_type)
      params.append('status', StatusEnum.ACTIVE)
      params.append('isControlProduct', true)
      let result = await jdaCategoryService.getMappingJDACategoryTreeNodeAsync(
        params
      )
      if (result.status === 200) {
        if (result.data && result.data.length > 0) {
          this.jdaCategoryItems = result.data
        } else {
          this.basicComponentModel.model.oracle_code = ''
        }
      } else {
        this.basicComponentModel.model.oracle_code = ''
      }
    },
    async getJDACategoryByIdAsync(id) {
      if (id && id !== '') {
        let params = new URLSearchParams()
        params.append('isRequireParent', true)
        let result = await jdaCategoryService.getJDACategoryDetailAsync(
          id,
          params
        )
        if (result.status === 200) {
          if (
            this.is_free === result.data.is_free &&
            this.vendor_type === result.data.type
          ) {
            let indexCategory = this.basicComponentModel.model.categories.findIndex(
              f => f.type === 'JDA'
            )
            if (indexCategory === -1) {
              indexCategory = this.basicComponentModel.model.categories.length
            }
            this.jda_category_id = result.data.id
            this.basicComponentModel.model.categories[indexCategory] = {
              type: 'JDA',
              id: result.data.id,
              parent_id: result.data.parent_id,
              level: result.data.level,
              code: result.data.code,
              display_name: {
                en: result.data.display_name.en,
                th: result.data.display_name.th,
              },
              parent_categories: result.data.parent_categories,
            }
            if (
              result.data.parent_categories &&
              result.data.parent_categories.length > 0
            ) {
              let jdaLevel2 = result.data.parent_categories.find(
                f => f.level === '2' || f.level === 2
              )
              if (jdaLevel2 && jdaLevel2.id !== '') {
                let params2 = new URLSearchParams()
                params.append('isRequireParent', false)
                let jda2 = await jdaCategoryService.getJDACategoryDetailAsync(
                  jdaLevel2.id,
                  params2
                )
                this.basicComponentModel.model.oracle_code =
                  jda2.data.oracle_code
              }
            }
          } else {
            let indexCategory = this.basicComponentModel.model.categories.findIndex(
              f => f.type === 'JDA'
            )
            if (indexCategory === -1) {
              indexCategory = this.basicComponentModel.model.categories.length
            }
            this.basicComponentModel.model.categories[indexCategory] = {
              type: 'JDA',
              id: '',
              parent_id: '',
              level: 0,
              code: '',
              display_name: { en: '', th: '' },
              parent_categories: [],
            }
            this.jda_category_id = ''
            this.basicComponentModel.model.oracle_code = ''
            this.isReloadJDACategorySelector = !this.isReloadJDACategorySelector
          }
        } else {
          console.log('error', result.response.data.message)
          let indexCategory = this.basicComponentModel.model.categories.findIndex(
            f => f.type === 'JDA'
          )
          if (indexCategory === -1) {
            indexCategory = this.basicComponentModel.model.categories.length
          }
          this.basicComponentModel.model.categories[indexCategory] = {
            type: 'JDA',
            id: '',
            parent_id: '',
            level: 0,
            code: '',
            display_name: { en: '', th: '' },
            parent_categories: [],
          }
          this.jda_category_id = ''
          this.basicComponentModel.model.oracle_code = ''
        }
      } else {
        let indexCategory = this.basicComponentModel.model.categories.findIndex(
          f => f.type === 'JDA'
        )
        if (indexCategory === -1) {
          indexCategory = this.basicComponentModel.model.categories.length
        }
        this.basicComponentModel.model.categories[indexCategory] = {
          type: 'JDA',
          id: '',
          parent_id: '',
          level: 0,
          code: '',
          display_name: { en: '', th: '' },
          parent_categories: [],
        }
        this.jda_category_id = ''
        this.basicComponentModel.model.oracle_code = ''
      }
    },
    async getJDACategoryByIdsAsync(ids) {
      if (ids && ids.length > 0) {
        let params = new URLSearchParams()
        ids.forEach(id => {
          params.append('ids', id)
        })
        params.append('isRequireParent', true)
        params.append('vendor_type', this.vendor_type)
        params.append('is_free', this.is_free)
        let result = await jdaCategoryService.getJDACategoryByIdsAsync(params)
        if (result.status === 200) {
          if (
            this.is_free === result.data.is_free &&
            this.vendor_type === result.data.type
          ) {
            let indexCategory = this.basicComponentModel.model.categories.findIndex(
              f => f.type === 'JDA'
            )
            if (indexCategory === -1) {
              indexCategory = this.basicComponentModel.model.categories.length
            }
            this.jda_category_id = result.data.id
            this.basicComponentModel.model.categories[indexCategory] = {
              type: 'JDA',
              id: result.data.id,
              parent_id: result.data.parent_id,
              level: result.data.level,
              code: result.data.code,
              display_name: {
                en: result.data.display_name.en,
                th: result.data.display_name.th,
              },
              parent_categories: result.data.parent_categories,
            }
            if (
              result.data.parent_categories &&
              result.data.parent_categories.length > 0
            ) {
              let jdaLevel2 = result.data.parent_categories.find(
                f => f.level === '2' || f.level === 2
              )
              if (jdaLevel2 && jdaLevel2.id !== '') {
                let params2 = new URLSearchParams()
                params.append('isRequireParent', false)
                let jda2 = await jdaCategoryService.getJDACategoryDetailAsync(
                  jdaLevel2.id,
                  params2
                )
                this.basicComponentModel.model.oracle_code =
                  jda2.data.oracle_code
              }
            }
          } else {
            let indexCategory = this.basicComponentModel.model.categories.findIndex(
              f => f.type === 'JDA'
            )
            if (indexCategory === -1) {
              indexCategory = this.basicComponentModel.model.categories.length
            }
            this.basicComponentModel.model.categories[indexCategory] = {
              type: 'JDA',
              id: '',
              parent_id: '',
              level: 0,
              code: '',
              display_name: { en: '', th: '' },
              parent_categories: [],
            }
            this.jda_category_id = ''
            this.basicComponentModel.model.oracle_code = ''
            this.isReloadJDACategorySelector = !this.isReloadJDACategorySelector
          }
        } else {
          console.log('error', result.response.data.message)
          let indexCategory = this.basicComponentModel.model.categories.findIndex(
            f => f.type === 'JDA'
          )
          if (indexCategory === -1) {
            indexCategory = this.basicComponentModel.model.categories.length
          }
          this.basicComponentModel.model.categories[indexCategory] = {
            type: 'JDA',
            id: '',
            parent_id: '',
            level: 0,
            code: '',
            display_name: { en: '', th: '' },
            parent_categories: [],
          }
          this.jda_category_id = ''
          this.basicComponentModel.model.oracle_code = ''
        }
      } else {
        let indexCategory = this.basicComponentModel.model.categories.findIndex(
          f => f.type === 'JDA'
        )
        if (indexCategory === -1) {
          indexCategory = this.basicComponentModel.model.categories.length
        }
        this.basicComponentModel.model.categories[indexCategory] = {
          type: 'JDA',
          id: '',
          parent_id: '',
          level: 0,
          code: '',
          display_name: { en: '', th: '' },
          parent_categories: [],
        }
        this.jda_category_id = ''
        this.basicComponentModel.model.oracle_code = ''
      }
    },
    async getOracleCodeByJDACategoryIdAsync(id) {
      let params = new URLSearchParams()
      params.append('isRequireParent', false)
      let result = await jdaCategoryService.getJDACategoryDetailAsync(
        id,
        params
      )
      if (result.status === 200) {
        this.basicComponentModel.model.oracle_code = result.data.oracle_code
      } else {
        console.log('error', result.response.data.message)
      }
    },
    async onJDACategorySelector(obj) {
      console.log('onJDACategorySelector', obj)
      this.isValidate.jdaCategory = false
      await this.getJDACategoryByIdAsync(obj.id)
      this.jda_category_id = obj.id
    },
    async getInventoryCategory(is_free, vendor_type) {
      this.inventoryCategoryItems = []
      let params = new URLSearchParams()
      params.append('is_free', is_free)
      params.append('type', vendor_type)
      params.append('status', StatusEnum.ACTIVE)
      params.append('isControlProduct', true)
      let result = await inventoryCategoryService.getMappingInventoryCategoryTreeNodeAsync(
        params
      )
      if (result.status === 200) {
        if (result.data && result.data.length > 0) {
          this.inventoryCategoryItems = result.data
        } else {
          this.basicComponentModel.model.gp_standard = 0
        }
      } else {
        this.basicComponentModel.model.gp_standard = 0
      }
    },
    async getInventoryCategoryByIdAsync(id) {
      if (id && id !== '') {
        let params = new URLSearchParams()
        params.append('isRequireParent', true)
        let result = await inventoryCategoryService.getInventoryCategoryDetailAsync(
          id,
          params
        )
        if (result.status === 200) {
          if (
            this.is_free === result.data.is_free &&
            this.vendor_type === result.data.type
          ) {
            let indexCategory = this.basicComponentModel.model.categories.findIndex(
              f => f.type === 'Inventory'
            )
            if (indexCategory === -1) {
              indexCategory = this.basicComponentModel.model.categories.length
            }
            this.inventory_category_id = result.data.id
            this.basicComponentModel.model.categories[indexCategory] = {
              type: 'Inventory',
              id: result.data.id,
              parent_id: result.data.parent_id,
              level: result.data.level,
              code: result.data.code,
              display_name: {
                en: result.data.display_name.en,
                th: result.data.display_name.th,
              },
              parent_categories: result.data.parent_categories,
            }
            if (!this.basicComponentModel.model.is_best_deal) {
              this.basicComponentModel.model.is_best_deal = result.data.parent_categories.some(
                s =>
                  (s.code === '4' || s.code === 4) &&
                  (s.level === '1' || s.level === 1)
              )
            }

            this.basicComponentModel.model.gp_standard = result.data.gp_standard
          } else {
            let indexCategory = this.basicComponentModel.model.categories.findIndex(
              f => f.type === 'Inventory'
            )
            if (indexCategory === -1) {
              indexCategory = this.basicComponentModel.model.categories.length
            }
            this.basicComponentModel.model.categories[indexCategory] = {
              type: 'Inventory',
              id: '',
              parent_id: '',
              level: 0,
              code: '',
              display_name: { en: '', th: '' },
              parent_categories: [],
            }
            this.inventory_category_id = ''
            this.basicComponentModel.model.gp_standard = 0
            this.isReloadInventoryCategorySelector = !this
              .isReloadInventoryCategorySelector
          }
        } else {
          console.log('error', result.response.data.message)

          let indexCategory = this.basicComponentModel.model.categories.findIndex(
            f => f.type === 'Inventory'
          )
          if (indexCategory === -1) {
            indexCategory = this.basicComponentModel.model.categories.length
          }
          this.basicComponentModel.model.categories[indexCategory] = {
            type: 'Inventory',
            id: '',
            parent_id: '',
            level: 0,
            code: '',
            display_name: { en: '', th: '' },
            parent_categories: [],
          }
          this.inventory_category_id = ''
          this.basicComponentModel.model.gp_standard = 0
        }
      } else {
        let indexCategory = this.basicComponentModel.model.categories.findIndex(
          f => f.type === 'Inventory'
        )
        if (indexCategory === -1) {
          indexCategory = this.basicComponentModel.model.categories.length
        }
        this.basicComponentModel.model.categories[indexCategory] = {
          type: 'Inventory',
          id: '',
          parent_id: '',
          level: 0,
          code: '',
          display_name: { en: '', th: '' },
          parent_categories: [],
        }
        this.inventory_category_id = ''
        this.basicComponentModel.model.gp_standard = 0
      }
    },
    async getInventoryCategoryByIdsAsync(ids) {
      if (ids && ids.length > 0) {
        let params = new URLSearchParams()
        ids.forEach(id => {
          params.append('ids', id)
        })

        params.append('isRequireParent', true)
        params.append('vendor_type', this.vendor_type)
        params.append('is_free', this.is_free)
        let result = await inventoryCategoryService.getInventoryCategoryByIdsAsync(
          params
        )
        if (result.status === 200) {
          if (
            this.is_free === result.data.is_free &&
            this.vendor_type === result.data.type
          ) {
            let indexCategory = this.basicComponentModel.model.categories.findIndex(
              f => f.type === 'Inventory'
            )
            if (indexCategory === -1) {
              indexCategory = this.basicComponentModel.model.categories.length
            }
            this.inventory_category_id = result.data.id
            this.basicComponentModel.model.categories[indexCategory] = {
              type: 'Inventory',
              id: result.data.id,
              parent_id: result.data.parent_id,
              level: result.data.level,
              code: result.data.code,
              display_name: {
                en: result.data.display_name.en,
                th: result.data.display_name.th,
              },
              parent_categories: result.data.parent_categories,
            }
            this.basicComponentModel.model.is_best_deal = result.data.parent_categories.some(
              s =>
                (s.code === '4' || s.code === 4) &&
                (s.level === '1' || s.level === 1)
            )
            this.basicComponentModel.model.gp_standard = result.data.gp_standard
          } else {
            let indexCategory = this.basicComponentModel.model.categories.findIndex(
              f => f.type === 'Inventory'
            )
            if (indexCategory === -1) {
              indexCategory = this.basicComponentModel.model.categories.length
            }
            this.basicComponentModel.model.categories[indexCategory] = {
              type: 'Inventory',
              id: '',
              parent_id: '',
              level: 0,
              code: '',
              display_name: { en: '', th: '' },
              parent_categories: [],
            }
            this.inventory_category_id = ''
            this.basicComponentModel.model.gp_standard = 0
            this.isReloadInventoryCategorySelector = !this
              .isReloadInventoryCategorySelector
          }
        } else {
          console.log('error', result.response.data.message)

          let indexCategory = this.basicComponentModel.model.categories.findIndex(
            f => f.type === 'Inventory'
          )
          if (indexCategory === -1) {
            indexCategory = this.basicComponentModel.model.categories.length
          }
          this.basicComponentModel.model.categories[indexCategory] = {
            type: 'Inventory',
            id: '',
            parent_id: '',
            level: 0,
            code: '',
            display_name: { en: '', th: '' },
            parent_categories: [],
          }
          this.inventory_category_id = ''
          this.basicComponentModel.model.gp_standard = 0
        }
      } else {
        let indexCategory = this.basicComponentModel.model.categories.findIndex(
          f => f.type === 'Inventory'
        )
        if (indexCategory === -1) {
          indexCategory = this.basicComponentModel.model.categories.length
        }
        this.basicComponentModel.model.categories[indexCategory] = {
          type: 'Inventory',
          id: '',
          parent_id: '',
          level: 0,
          code: '',
          display_name: { en: '', th: '' },
          parent_categories: [],
        }
        this.inventory_category_id = ''
        this.basicComponentModel.model.gp_standard = 0
      }
    },
    async getGPStandardInventoryCategoryIdAsync(id) {
      let params = new URLSearchParams()
      params.append('isRequireParent', true)
      let result = await inventoryCategoryService.getInventoryCategoryDetailAsync(
        id,
        params
      )
      if (result.status === 200) {
        this.basicComponentModel.model.gp_standard = result.data.gp_standard
      } else {
        console.log('error', result.response.data.message)
      }
    },
    async onInventoryCategorySelector(obj) {
      this.isValidate.inventoryCategory = false
      if (obj && obj.value && obj.value.length > 0) {
        if (obj.value.length > 1) {
          await this.getGPStandardInventoryCategoryIdAsync(obj.value[1].id)
        }
      }
      await this.getInventoryCategoryByIdAsync(obj.id)
      this.inventory_category_id = obj.id
    },

    async getOnlineCategory() {
      this.onlineCategoryItems = []
      let params = new URLSearchParams()
      params.append('status', StatusEnum.ACTIVE)
      params.append('isControlProduct', true)
      let result = await onlineCategoryService.getMappingOnlineCategoryTreeNodeAsync(
        params
      )
      if (result.status === 200) {
        if (result.data && result.data.length > 0) {
          this.onlineCategoryItems = result.data
        }
      }
    },
    async getOnlineCategoryByIdAsync(id) {
      if (id && id !== '') {
        let params = new URLSearchParams()
        params.append('isRequireParent', true)
        let result = await onlineCategoryService.getOnlineCategoryDetailAsync(
          id,
          params
        )
        if (result.status === 200) {
          let indexCategory = this.basicComponentModel.model.categories.findIndex(
            f => f.type === 'Online'
          )
          if (indexCategory === -1) {
            indexCategory = this.basicComponentModel.model.categories.length
          }
          this.online_category_id = result.data.id
          this.basicComponentModel.model.categories[indexCategory] = {
            type: 'Online',
            id: result.data.id,
            parent_id: result.data.parent_id,
            level: result.data.level,
            code: result.data.code,
            display_name: {
              en: result.data.display_name.en,
              th: result.data.display_name.th,
            },
            parent_categories: result.data.parent_categories,
          }
          // this.isReloadOnlineCategorySelector = !this.isReloadOnlineCategorySelector
        } else {
          console.log('error', result.response.data.message)
          let indexCategory = this.basicComponentModel.model.categories.findIndex(
            f => f.type === 'Online'
          )
          if (indexCategory === -1) {
            indexCategory = this.basicComponentModel.model.categories.length
          }
          this.online_category_id = ''
          this.basicComponentModel.model.categories[indexCategory] = {
            type: 'Online',
            id: '',
            parent_id: '',
            level: '',
            code: '',
            display_name: {
              en: '',
              th: '',
            },
            parent_categories: [],
          }
        }
      } else {
        let indexCategory = this.basicComponentModel.model.categories.findIndex(
          f => f.type === 'Online'
        )
        if (indexCategory === -1) {
          indexCategory = this.basicComponentModel.model.categories.length
        }
        this.basicComponentModel.model.categories[indexCategory] = {
          type: 'Online',
          id: '',
          parent_id: '',
          level: '',
          code: '',
          display_name: {
            en: '',
            th: '',
          },
          parent_categories: [],
        }
      }
    },
    async onOnlineCategorySelector(obj) {
      this.isValidate.onlineCategory = false
      await this.getOnlineCategoryByIdAsync(obj.id)
      this.online_category_id = obj.id
    },
    async onGetSeriesSelector(keyword) {
      this.options_series = []
      let params = new URLSearchParams()
      params.append('pageSize', 10)
      params.append('sort', 'display_name.en display_name.th')
      params.append('status', StatusEnum.ACTIVE)
      params.append('isExactlyKeywordMatch', true)
      params.append('keyword', keyword.trim())
      let result = await seriesService.getSeriesMasterListAsync(params)
      if (result.status === 200) {
        result.data.items.forEach((element, index) => {
          this.options_series[index] = {
            id: element.id,
            display_name: {
              th: element.display_name.th,
              en: element.display_name.en,
            },
          }
        })
      } else {
        if (result.response.data.message) {
          console.log(result.response.data.message)
        }
      }
    },
    async onGetBrandSelector(keyword) {
      this.options_brand = []
      let params = new URLSearchParams()
      params.append('pageSize', 10)
      params.append('sort', 'display_name.en display_name.th')
      params.append('status', StatusEnum.ACTIVE)
      params.append('isExactlyKeywordMatch', true)
      params.append('keyword', keyword.trim())
      let result = await brandService.getBrandMasterListAsync(params)
      if (result.status === 200) {
        result.data.items.forEach((element, index) => {
          this.options_brand[index] = {
            id: element.id,
            display_name: {
              th: element.display_name.th,
              en: element.display_name.en,
            },
            is_own_brand: element.is_own_brand,
          }
        })
      } else {
        if (result.response.data.message) {
          console.log(result.response.data.message)
        }
      }
    },
    setIsOwnBrand(val) {
      // console.log(val)
      if (val.id) {
        eventBus.$emit('setIsOwnBrand', val.id)
      }
    },
    onSubmit() {
      if (
        this.basicComponentModel.model.categories.some(
          f => f.type == 'Hybrid'
        ) &&
        this.basicComponentModel.model.categories.find(f => f.type == 'Hybrid')
          .id === ''
      ) {
        this.isValidate.hybridCategory = true
      }
      if (
        this.basicComponentModel.model.categories.some(
          f => f.type == 'Inventory'
        ) &&
        this.basicComponentModel.model.categories.find(
          f => f.type == 'Inventory'
        ).id === ''
      ) {
        this.isValidate.inventoryCategory = true
      }
      if (
        this.basicComponentModel.model.categories.some(f => f.type == 'JDA') &&
        this.basicComponentModel.model.categories.find(f => f.type == 'JDA')
          .id === ''
      ) {
        this.isValidate.jdaCategory = true
      }
      if (
        this.basicComponentModel.model.categories.some(
          f => f.type == 'Online'
        ) &&
        this.basicComponentModel.model.categories.find(f => f.type == 'Online')
          .id === ''
      ) {
        this.isValidate.onlineCategory = true
      }
      this.$refs.componentForm.validate().then(result => {
        this.basicComponentModel.validateState = result
        this.modelChanged()
      })
    },
    onReset() {},
    addCommentClick() {
      eventBus.$emit('regist_product_comment_click', this.$options.name)
    },
  },
}
</script>